import React from "react";
import { useTranslation } from "react-i18next";
import { CheckboxIcon, CrossIcon } from "@aureskonnect/react-ui";
import { AvForm } from "availity-reactstrap-validation";
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { mutate } from "swr";

import { store } from "@components/VerticalLayout/store";
import { setIsEdited, setIsLoading, setShopDataIsUpdated } from "../store";

import {
    CustomCardFooter,
    CustomCardHeader,
} from "../../../../components/Common/CustomCardStyled";
import { capitalize } from "../../../../helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { ThirdPartyConfigureType } from "../Types";
import { CreateDataThirdParty } from "../helper";
import { emailMatchWord } from "@constants/index";
import { CreateEmployeeBody } from "./CreateEmployeeBody";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

export function CreateEmployeeModal({ data }: ThirdPartyConfigureType) {
    const { t } = useTranslation();
    const { userID, operatorID, franchiseID } = useSnapshot(store);
    const uuidUser = localStorage.getItem("uuidUser");

    const [role, setRole] = React.useState<string>("");
    const [inputRole, setInputRole] = React.useState<boolean>(false);

    const [firstName, setFirstName] = React.useState<string>("");
    const [inputFirstName, setInputFirstName] = React.useState<boolean>(false);
    const [lastName, setLastName] = React.useState<string>("");
    const [inputLastName, setInputLastName] = React.useState<boolean>(false);
    const [email, setEmail] = React.useState<string>("");
    const [inputEmail, setInputEmail] = React.useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = React.useState<string>("");
    const [inputPhoneNumber, setInputPhoneNumber] = React.useState<boolean>(
        false
    );
    const [code, setCode] = React.useState<any>("33");
    const [isEmailExist, setEmailExist] = React.useState<boolean>(false);
    const [isEmailInvalid, setEmailInvalid] = React.useState<boolean>(false);
    async function AddEmployee() {
        toast.dismiss();
        if (firstName === "") {
            setInputFirstName(true);
        }
        if (lastName === "") {
            setInputLastName(true);
        }
        if (email === "") {
            setInputEmail(true);
        }
        if (email !== "" && !email.match(emailMatchWord)) {
            setEmailInvalid(true);
        }
        if (phoneNumber === "") {
            setInputPhoneNumber(true);
        }
        if (role === "") {
            setInputRole(true);
        }
        if (
            role !== "" &&
            firstName !== "" &&
            lastName !== "" &&
            email !== "" &&
            phoneNumber !== "" &&
            email.match(emailMatchWord) &&
            !isEmailExist &&
            !isEmailInvalid
        ) {
            let dataEmployee = {
                role,
                firstName,
                lastName,
                email,
                phoneNumber,
                code,
                new: true,
            };
            let dataThirdParty = CreateDataThirdParty(
                false,
                false,
                data.rowData.shopId,
                data.rowData.isActive,
                data.rowData.isFavorite,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                data.rowData.Id,
                data.rowData[t("Third party")],
                data.rowData.ip,
                data.rowData.portApi,
                data.rowData.salesId,
                data.rowData.menusId,
                data.rowData.baseUrl,
                data.rowData.remark,
                false,
                data.rowData.apiKey,
                data.rowData.organization,
                [...data.rowData.employee, dataEmployee]
            );

            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/thirdParty`;
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify([{ ...dataThirdParty, user: true }]),
            };

            try {
                const response = await fetch(apiUrlAdd, requestOptions);
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || response.statusText);
                }
                const result = await response.json();
                toast.success(
                    `${t("The organization was created successfully.")!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                data.setIsModalOpened(false);
                setShopDataIsUpdated(true);
                setIsEdited(false);
                setIsEdited(false);
                setIsLoading(false);
                mutate(apiUrlAdd, result);
            } catch (e: any) {
                toast.error(`${t(`${e}`)!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setIsLoading(false);
            }
        }
    }

    return (
        <React.Fragment>
            <Modal
                centered
                isOpen={data.isModalOpened}
                className="information_fidelity_modal__clz mt-5"
            >
                <AvForm className="card information_fidelity__clz">
                    <CustomCardHeader className="d-flex align-items-center justify-content-between">
                        <h5 className="pt-3">
                            {capitalize(t("Add employee"))}
                        </h5>
                        <CrossIcon
                            className="icon-close-notification__clz"
                            height={13}
                            width={13}
                            onClick={() => {
                                data.setIsModalOpened(false);
                            }}
                        />
                    </CustomCardHeader>
                    <CreateEmployeeBody
                        data={{
                            setCode,
                            editedData: data.rowData,
                            role,
                            setRole,
                            firstName,
                            setFirstName,
                            inputFirstName,
                            setInputFirstName,
                            lastName,
                            setLastName,
                            inputLastName,
                            setInputLastName,
                            email,
                            setEmail,
                            inputEmail,
                            setInputEmail,
                            phoneNumber,
                            setPhoneNumber,
                            inputPhoneNumber,
                            setInputPhoneNumber,
                            inputRole,
                            setInputRole,
                            isConsult: data.isConsult,
                            isConfig: true,
                            setEmailExist,
                            isEmailExist,
                            isEmailInvalid,
                            setEmailInvalid,
                        }}
                    />
                    <CustomCardFooter className="pt-1 pb-2 mt-4">
                        <CustomSecondaryColorButton
                            outline
                            rounded
                            className="mr-2 fed_btn_FRcancel cmn_btn_cancel"
                            variant="light"
                            onClick={() => {
                                data.setIsModalOpened(false);
                                setIsEdited(false);
                            }}
                        >
                            <span> {t("Cancel")}</span>
                        </CustomSecondaryColorButton>
                        <CustomMainColorButton
                            variant="primary"
                            onClick={() => {
                                AddEmployee();
                                setIsEdited(false);
                            }}
                            rounded
                        >
                            {t("Validate")}
                        </CustomMainColorButton>
                    </CustomCardFooter>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
}
